module.exports = __webpack_public_path__ + "img/chervec.177e2cef.jpg";